import React from 'react'
function ErrorBox(props) {
  const { src, label } = props
  return (
    <div style={{ padding: '2em', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <img src={src} style={{ width: '190px', height: '100px' }} />
      <div style={{ textAlign: 'center', fontSize: '14px', fontFamily: 'JioType-Medium', color: '#050000' }}>{label}</div>
    </div>
  )
}

export default ErrorBox
